<script>
import {
    eventGroupState
} from '@app/store/eventGroupStore.svelte.js';
import {
    projectState
} from '@app/store/projectStore.svelte.js';
import {
    insertHistoryAction
} from '@app/store/historyStore.svelte.js';
import {
    editorState
} from "@app/store/editorStore.svelte.js";
import insertEv from '@cclib/functions/eventGroups/insertEvent.js';
import * as m from '@app/paraglide/messages.js';

function insertEvent() {
    try {
        if (!eventGroupState[projectState.selected]){
            return;
        }
        
        let eventOptions;
        let eventIndex = eventGroupState[projectState.selected].selected.length > 0 ? eventGroupState[projectState.selected].selected[0] + 1 : null;
        
        if (eventGroupState[projectState.selected].events.length > 0){
            try {
                let eventTemplate = eventGroupState[projectState.selected].selected.length > 0 ? eventGroupState[projectState.selected].events[eventGroupState[projectState.selected].selected[0]] : eventGroupState[projectState.selected].events[eventGroupState[projectState.selected].events.length-1];

                eventOptions = {
                    ...eventOptions,
                    alignment : eventTemplate.alignment, 
                    xPos : eventTemplate.xPos,
                    yPos : eventTemplate.yPos,
                    vertical : eventTemplate.vertical,
                    voice : eventTemplate.voice,
                    speakingStyle : eventTemplate.speakingStyle,
                    style : eventTemplate.style,
                    rate : eventTemplate.rate,
                    start: editorState.insertStartOnInsert ? player.currentTime : false,
                    end: editorState.insertStartOnInsert ? player.currentTime + eventGroupState[projectState.selected].minDuration : false,
                }     
            } catch(err){
                console.log(err);
            }
        }
        
        eventGroupState[projectState.selected] = insertEv(eventGroupState[projectState.selected], eventOptions, eventIndex);        
        editorState.editing = true;
        window.focus();
        eventGroupState[projectState.selected].selected = eventIndex !== null ? [eventIndex] : [eventGroupState[projectState.selected].events.length - 1];

        const selectedIndex = eventGroupState[projectState.selected].selected[0];
        
        // Dispatch custom event to scroll to the newly added event
        window.dispatchEvent(new CustomEvent('scrollToVirtualListItem', {
            detail: { index: selectedIndex }
        }));

        /* Store in History */
        insertHistoryAction({
            name : "insert event", //action name
            eventGroup : projectState.selected,
            snapshots : [
                {
                    store : "eventGroupState",
                    value : JSON.stringify(eventGroupState)
                }
            ]
        });
    } catch(err){
        console.log(err, err.message);
    }
}
</script>
<li class="nav-item" title={m.add_event_title()}>
    <a
        class="nav-link" 
        href="#!/" 
        id="add-event-btn"
        role="button"
        aria-label={m.add_event_aria_label()}
        onclick={insertEvent}
    ><i class="bi bi-plus-circle"></i></a>
</li>
